import * as React from 'react';
import * as S from './styles';
import {IProps} from './types'
import FilterCheck from 'components/Filter';

const Provider  : React.FC<IProps> = ({value, selected, label, onChange, hideBars}) => {
    const [checked, setChecked] = React.useState<boolean>(false);

    React.useEffect(() => {
        setChecked(selected);
    }, [selected])

    return (
        <S.MainContainer>
            <S.Column>
                <FilterCheck
                key={`status`}
                label={label}
                type="templateStatus"
                onChange={() => {
                    setChecked(!checked)
                    onChange(!checked, label);
                }}
                checked={checked}
                styleRoot={{padding: '0px 0px'}}
                styledCheckbox={{
                    borderRadius: '5px',
                    border: checked ? 'none' : 'solid 2px rgba(189, 189, 189, 0.5)',
                    background: checked ?'#2b3a66' : '#fff',
                    width: checked ? '22px' : '19.5px',
                    height: checked ? '22px' : '19.5px',
                }}
                styleLabel={{
                    fontSize: '14px',
                    color: '#000',
                    marginLeft: '9px'
                }}
                stroke='#fff'
                />
            </S.Column>
            {!hideBars &&
            <S.Column>
            <S.ProgressBar>
				<S.ProgressFill style={{width: `${(Math.round(value)/5)* 100}%`}}>
                    <S.Value>{Math.round(value)}</S.Value>
                </S.ProgressFill>
			</S.ProgressBar>
            </S.Column>}
        </S.MainContainer>
    )
}

export default Provider;
